export default function PrivacyPolicy() {
  return (
    <>
      <h2>1. Mi a tájékoztató célja?</h2>
      <p>
        Jelen Tájékoztatót abból a célból fogadjuk el, hogy szolgáltatásainkat
        igénybe vevő természetes személyek és jogi személyek képviselői (a
        továbbiakban: Felhasználók) részére minden lényeges információt és
        tájékoztatást tömör, átlátható, érthető és könnyen hozzáférhető
        formában, világosan és közérthetően megfogalmazva közöljünk, valamint
        segítsük az Ügyfeleket a 4. pontban szereplő jogaik gyakorlásában.
      </p>
      <p>
        Tájékoztatási kötelezettségünk alapja a 2018. május 25. napjától
        alkalmazandó, az Európai Parlament és Tanács (EU) 2016/679. számú
        Rendelet (a továbbiakban:{' '}
        <a href="https://eur-lex.europa.eu/legal-content/HU/TXT/?uri=celex%3A32016R0679">
          GDPR
        </a>
        ) 12. cikke, az önrendelkezési jogról és az információszabadságról 2011.
        évi CXII. törvény (a továbbiakban:{' '}
        <a href="https://net.jogtar.hu/jogszabaly?docid=A1100112.TV">Infotv.</a>
        ) 16. §-a, illetve az elektronikus kereskedelmi szolgáltatások, valamint
        az információs társadalommal összefüggő szolgáltatások egyes kérdéseiről
        szóló 2001. évi CVIII. törvény (
        <a href="https://net.jogtar.hu/jogszabaly?docid=a0100108.tv">
          Elkertv.
        </a>
        ) 4. §-a.
      </p>
      <p>
        A Tájékoztató a GDPR, az Infotv., valamint az egyes adatkezelések
        szempontjából releváns további jogszabályok figyelembevételével készült.
        A jogszabályok felsorolását a Tájékoztató 1. számú melléklete, a
        legfontosabb fogalmak ismertetését pedig a 2. számú melléklet
        tartalmazza.
      </p>
      <p>
        Jelen tájékoztató kialakítása és alkalmazása során a Nemzeti Adatvédelmi
        és Információszabadság Hatóságnak az előzetes tájékoztatás adatvédelmi
        követelményeiről szóló{' '}
        <a href="https://www.naih.hu/files/tajekoztato-ajanlas-v-2015-10-09.pdf">
          ajánlásban
        </a>{' '}
        foglalt megállapítások, valamint a GDPR 5. cikkének figyelembevételével,
        különösen az 5. cikk (2) bekezdésében szereplő elszámoltathatóság
        elvének szellemében jártunk el.
      </p>
      <h2>2. Adatkezelő adatai</h2>
      <table className="table">
        <tbody>
          <tr>
            <td width="192">Név</td>
            <td width="413">Salai-Boldizsár Levente egyéni vállalkozó</td>
          </tr>
          <tr>
            <td width="192">Székhely</td>
            <td width="413">3533 Miskolc, Szeder utca 76. 2. em. 6. ajtó</td>
          </tr>
          <tr>
            <td width="192">Telefon</td>
            <td width="413">+36 30 921 95 61</td>
          </tr>
          <tr>
            <td width="192">E-mail</td>
            <td width="413">pixwrist@pixwrist.hu</td>
          </tr>
          <tr>
            <td width="192">Web</td>
            <td width="413">www.pixwrist.hu</td>
          </tr>
          <tr>
            <td width="192">Nyilvántartásba vevő hatóság</td>
            <td width="413">Nemzeti Adó- és Vámhivatal</td>
          </tr>
          <tr>
            <td width="192">Nyilvántartási szám</td>
            <td width="413">55017006</td>
          </tr>
          <tr>
            <td width="192">Adószám</td>
            <td width="413">56377169-1-25</td>
          </tr>
        </tbody>
      </table>
      <h2>3. Milyen adatkezelési folyamatok történnek a Weboldalon?</h2>
      <p>
        Jelen pontban részletezzük az egyes adatkezelésekhez tartozó azon
        lényeges körülményeket, melyeket a GDPR és az egyéb ágazati jogszabályok
        elvárnak minden adatkezelőtől.
      </p>
      <p>
        <strong>
          <em>3.1. Hírlevél-küldéshez kapcsolódó adatkezelés</em>
        </strong>
      </p>
      <p>
        Annak érdekében, hogy naprakész információkkal lássuk el Weboldalunk
        látogatóit, lehetőség van feliratkozni hírlevelünkre. Az ezzel
        kapcsolatos adatkezelésre az alábbi információk vonatkoznak:
      </p>
      <p>
        <em>
          3.1.1. <u>A kezelt személyes adatok és az adatkezelés célja</u>
        </em>
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td width="307">személyes adat</td>
            <td width="307">adatkezelés célja</td>
          </tr>
          <tr>
            <td width="307">név</td>
            <td width="307">
              ennek megadásával hírlevelünkben meg tudjuk szólítani a
              Felhasználót
            </td>
          </tr>
          <tr>
            <td width="307">e-mail cím</td>
            <td width="307">
              ennek megadásával ismerjük meg a Felhasználó elektronikus
              elérhetőséget, ahova küldeni tudjuk hírlevelünket
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <em>
          3.1.2. <u>Az adatkezelés jogalapja</u>
        </em>
      </p>
      <p>
        A Felhasználó hozzájárulása (GDPR 6. cikk (1) a) pontja, illetve a
        gazdasági reklámtevékenység alapvető feltételeiről és egyes korlátairól
        szóló 2008. évi XLVIII. törvény (a továbbiakban:{' '}
        <a href="https://net.jogtar.hu/jogszabaly?docid=A0800048.TV">Grt.</a>)
        6. § (1) bekezdése).
      </p>
      <p>
        <em>
          3.1.3. <u>Az adatkezelés időtartama</u>
        </em>
      </p>
      <p>
        A megadott személyes adatokat a hozzájárulás visszavonásáig kezeljük.
        Hozzájárulását a kiküldött levélben található „Leiratkozás” gombra való
        kattintással a Felhasználó bármikor visszavonhatja.
      </p>
      <p>
        <em>
          3.1.4. <u>Az adatkezelés módja</u>
        </em>
      </p>
      <p>Elektronikus formában.</p>
      <p>
        <strong>
          <em>3.2. Kapcsolatfelvétellel összefüggő adatkezelés</em>
        </strong>
      </p>

      <p>
        Weboldalunkon keresztül fel lehet venni velünk a kapcsolatot bármilyen
        célból. Az ehhez kapcsolódó adatkezelés részletei az alábbiakban
        láthatóak.
      </p>

      <p>
        <em>
          3.2.1. <u>A kezelt személyes adatok és az adatkezelés célja</u>
        </em>
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td width="307">személyes adat</td>
            <td width="307">adatkezelés célja</td>
          </tr>
          <tr>
            <td width="307">név</td>
            <td width="307">Felhasználó beazonosítása</td>
          </tr>
          <tr>
            <td width="307">e-mail cím</td>
            <td width="307">kapcsolatfelvétel a Felhasználóval</td>
          </tr>
          <tr>
            <td width="307">telefonszám</td>
            <td width="307">kapcsolatfelvétel a Felhasználóval</td>
          </tr>
        </tbody>
      </table>

      <p>
        <em>
          3.2.2. <u>Az adatkezelés jogalapja</u>
        </em>
      </p>
      <p>
        Jogszabályon alapuló adatkezelés; GDPR 6. cikk (1) c) pontjára és (2)
        bekezdésére figyelemmel az Info tv. 5. § (1) b) pontja és az Elkertv.
        13/A. § (1) és (3) bekezdései.
      </p>

      <p>
        <em>
          3.2.3. <u>Az adatkezelés időtartama</u>
        </em>
      </p>
      <p>A kapcsolatfelvételt követő 1 évig.</p>

      <p>
        <em>
          3.2.4. <u>Az adatkezelés módja</u>
        </em>
      </p>
      <p>Elektronikus formában.</p>

      <p>
        <strong>
          <em>3.3. Megrendelésekkel kapcsolatos adatkezelés</em>
        </strong>
      </p>

      <p>
        Weboldalunkon lehetőség van különféle termékek megrendelésére. Az ehhez
        kapcsolódó adatkezeléseket ismertetjük jelen pontban.
      </p>

      <p>
        <em>
          3.3.1. <u>A kezelt személyes adatok és az adatkezelés célja</u>
        </em>
      </p>

      <table className="table">
        <tbody>
          <tr>
            <td width="307">személyes adat</td>
            <td width="307">adatkezelés célja</td>
          </tr>
          <tr>
            <td width="307">név</td>
            <td width="307">
              a megrendelés teljesítése során a név megadásával tudjuk
              azonosítani a termék megrendelőjét
            </td>
          </tr>
          <tr>
            <td width="307">
              lakcím (irányítószám, város, utcanév, házszám együtt)
            </td>
            <td width="307">
              a megadott címre tudjuk postai úton megküldeni a megrendelt
              terméket
            </td>
          </tr>
          <tr>
            <td width="307">telefonszám</td>
            <td width="307">
              a megrendelővel történő kapcsolattartás és tájékoztatás a
              megrendelés részleteiről
            </td>
          </tr>
          <tr>
            <td width="307">e-mail cím</td>
            <td width="307">
              a megrendelővel történő kapcsolattartás és tájékoztatás a
              megrendelés részleteiről
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        <em>
          3.3.2. <u>Az adatkezelés jogalapja</u>
        </em>
      </p>
      <p>
        Szerződés teljesítése, melynek felei az Adatkezelő és a Felhasználó
        (GDPR 6. cikk (1) b) pont)
      </p>
      <p>
        Ha a megrendelő jogi személy, kapcsolattartójának fenti személyes adatai
        kezelésének jogalapja az adatkezelői és a megrendelői jogos érdek (GDPR
        6. cikk (1) f) pont). Mindkét fél jogos érdeke, hogy a megrendelés során
        hatékonyan történjen az üzleti kommunikáció és bármilyen, a köztünk
        létrejött szerződést érintő lényeges körülményről tájékoztatást tudjunk
        nyújtani egymás kijelölt képviselőjének. A megrendelő
        kapcsolattartójának információs önrendelkezési jogának sérelme nem
        állapítható meg, mert munkaköri, vagy szerződéses kötelezettsége
        elősegíteni a felek közötti kommunikációt és megadni személyes adatait
        ebből a célból.
      </p>

      <p>
        <em>
          3.3.3. <u>Az adatkezelés időtartama</u>
        </em>
      </p>
      <p>
        Figyelemmel a Polgári Törvénykönyvről szóló 2013. évi V. törvény (
        <a href="https://net.jogtar.hu/jogszabaly?docid=A1300005.TV">Ptk.</a>)
        6:22. § (1) bekezdésére, a fenti célok érdekében a megrendelés
        teljesítését követő 5 évig tároljuk a megadott személyes adatokat.
      </p>

      <p>
        <em>
          3.3.4. <u>Az adatkezelés módja</u>
        </em>
      </p>
      <p>Elektronikus formában.</p>

      <p>
        <em>
          3.3.5. <u>A személyes adatok szolgáltatása</u>
        </em>
      </p>
      <p>
        Tekintettel arra, hogy a jelen pontban szereplő személyes adatok
        ismerete nélkül a megrendeléseket nem tudjuk teljesíteni, a személyes
        adatok megadása szerződés kötésének előfeltétele.
      </p>

      <p>
        <strong>
          <em>3.4. Számla-kiállítással kapcsolatos adatkezelések</em>
        </strong>
      </p>

      <p>
        A megrendelések teljesítését követően – figyelemmel a számvitelről szóló
        2000. évi C. törvényre (a továbbiakban:{' '}
        <a href="https://net.jogtar.hu/jogszabaly?docid=A0000100.TV">Sztv.</a>)
        – számviteli bizonylatot állítunk ki. Az ezzel kapcsolatos adatkezelések
        részletei az alábbiakban láthatóak.
      </p>

      <p>
        <em>
          3.4.1. <u>A kezelt személyes adatok és az adatkezelés célja</u>
        </em>
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td width="307">személyes adat</td>
            <td width="307">adatkezelés célja</td>
          </tr>
          <tr>
            <td width="307">név</td>
            <td width="307">
              a megrendelés teljesítéséről (gazdasági esemény) való számviteli
              elszámolás alátámasztása
            </td>
          </tr>
          <tr>
            <td width="307">
              lakcím/egyéni vállalkozónál székhely (irányítószám, város,
              utcanév, házszám együtt)
            </td>
            <td width="307">
              a megrendelés teljesítéséről (gazdasági esemény) való számviteli
              elszámolás alátámasztása
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        <em>
          3.4.2. <u>Az adatkezelés jogalapja</u>
        </em>
      </p>
      <p>
        Jogszabályon alapuló adatkezelés (GDPR 6. cikk (1) c) pontjára
        figyelemmel az Info tv. 5. § (1) b) pontja és az Sztv. 166. § (1)-(3)
        bekezdései).
      </p>

      <p>
        <em>
          3.4.3. <u>Az adatkezelés időtartama</u>
        </em>
      </p>
      <p>
        A számviteli bizonylat kiállítását követő 8 évig (Sztv. 166. § (6)
        bekezdésére figyelemmel az Sztv. 169. § (1) bekezdése
      </p>

      <p>
        <em>
          3.4.4. <u>Az adatkezelés módja</u>
        </em>
      </p>
      <p>Elektronikus formában.</p>

      <p>
        <em>
          3.4.5. <u>A személyes adatok szolgáltatása</u>
        </em>
      </p>
      <p>
        Tekintettel arra, hogy a jelen pontban szereplő személyes adatok
        ismerete nélkül nem tudunk számviteli bizonylatot kiállítani, a
        személyes adatok szolgáltatása jogszabályon alapul.
      </p>

      <p>
        <strong>
          <em>3.5. Ügyfélszolgálattal kapcsolatos adatkezelések</em>
        </strong>
      </p>

      <p>
        A Felhasználók kérdéseire történő válaszadás, illetve az esetleges
        panaszok kivizsgálása céljából ügyfélszolgálatot tartunk fenn
        Weboldalunkon.
      </p>

      <p>
        <em>
          3.5.1. <u>A kezelt személyes adatok és az adatkezelés célja</u>
        </em>
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td width="307">személyes adat</td>
            <td width="307">adatkezelés célja</td>
          </tr>
          <tr>
            <td width="307">név</td>
            <td width="307">a Felhasználó beazonosítása</td>
          </tr>
          <tr>
            <td width="307">e-mail cím</td>
            <td width="307">
              a Felhasználóval történő kapcsolattartás és tájékoztatás nyújtása
            </td>
          </tr>
          <tr>
            <td width="307">telefonszám</td>
            <td width="307">
              a Felhasználóval történő kapcsolattartás és tájékoztatás nyújtása
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        <em>
          3.5.2. <u>Az adatkezelés jogalapja</u>
        </em>
      </p>
      <p>
        Jogszabályon alapuló adatkezelés; GDPR 6. cikk (1) c) pontjára és (2)
        bekezdésére figyelemmel az Info tv. 5. § (1) b) pontja és a
        fogyasztóvédelemről szóló 1997. évi CLV. törvény (
        <a href="https://net.jogtar.hu/jogszabaly?docid=99700155.TV">Fgytv.</a>)
      </p>

      <p>
        <em>
          3.5.3. <u>Az adatkezelés időtartama</u>
        </em>
      </p>
      <p>
        Az Fgytv. 17/A. § (7) bekezdésére figyelemmel a panasz beérkezésétől
        számított 5 évig.
      </p>

      <p>
        <em>
          3.5.4. <u>Az adatkezelés módja</u>
        </em>
      </p>
      <p>Elektronikus formában.</p>

      <p>
        <strong>
          <em>3.6. Termék értékeléssel összefüggő adatkezelés</em>
        </strong>
      </p>

      <p>
        A Weboldalon a megvásárolt termékekről értékelést lehet írni, amelyek a
        termékoldalakon nyilvánosan megjelennek. Az értékeléseket a Stamped.io
        szolgáltatás (lásd 6.6. pont) segítségével gyűjtjük és jelenítjük meg. A
        vásárlást követően e-mailben megkérhetjük a Felhasználót, hogy értékelje
        a megvásárolt terméket. Az ehhez kapcsolódó adatkezelés részletei az
        alábbiakban láthatóak.
      </p>

      <p>
        <em>
          3.6.1. <u>A kezelt személyes adatok és az adatkezelés célja</u>
        </em>
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td width="307">személyes adat</td>
            <td width="307">adatkezelés célja</td>
          </tr>
          <tr>
            <td width="307">név</td>
            <td width="307">
              az értékelés szerzőjének feltüntetése az értékelés mellett (az
              értékeléssel együtt nyilvánosan megjelenik)
            </td>
          </tr>
          <tr>
            <td width="307">e-mail cím</td>
            <td width="307">
              az értékelés kérése, valamint az értékeléssel kapcsolatos
              kapcsolattartás a Felhasználóval (nem jelenik meg nyilvánosan)
            </td>
          </tr>
          <tr>
            <td width="307">a megvásárolt termék</td>
            <td width="307">
              az értékelés termékhez rendelése, valamint annak jelölése, hogy az
              értékelés a terméket ténylegesen megvásárló Felhasználótól
              származik
            </td>
          </tr>
          <tr>
            <td width="307">
              az értékelés tartalma (pontszám, szöveges vélemény, a Felhasználó
              által feltöltött fényképek)
            </td>
            <td width="307">
              a termékről alkotott vélemény megjelenítése a Weboldalon
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        <em>
          3.6.2. <u>Az adatkezelés jogalapja</u>
        </em>
      </p>
      <p>
        Az értékelés beküldése és megjelenítése esetén a Felhasználó
        hozzájárulása (GDPR 6. cikk (1) a) pontja), amelyet az értékelés
        beküldésével ad meg. A hozzájárulás bármikor visszavonható, ebben az
        esetben az értékelést eltávolítjuk. Az értékelés kéréséhez kapcsolódó
        e-mail küldése esetén az adatkezelő jogos érdeke (GDPR 6. cikk (1) f)
        pontja), amely a megvásárolt termékekkel kapcsolatos vásárlói
        visszajelzések gyűjtése; a Felhasználó ez ellen tiltakozhat (lásd 4.
        pont).
      </p>

      <p>
        <em>
          3.6.3. <u>Az adatkezelés időtartama</u>
        </em>
      </p>
      <p>
        Az értékelést és a hozzá kapcsolódó adatokat a hozzájárulás
        visszavonásáig, illetve az értékelés Weboldalról történő eltávolításáig
        kezeljük.
      </p>

      <p>
        <em>
          3.6.4. <u>Az adatkezelés módja</u>
        </em>
      </p>
      <p>Elektronikus formában.</p>

      <p>
        <strong>
          <em>
            3.7. A Weboldal működésének és hibáinak monitorozásával összefüggő
            adatkezelés
          </em>
        </strong>
      </p>

      <p>
        A Weboldal stabil és biztonságos működése, valamint az esetleges hibák
        felderítése és javítása érdekében a Microsoft Azure Application Insights
        szolgáltatásával technikai adatokat gyűjtünk a Weboldal használatáról.
        Az adatok alapján a Felhasználót személy szerint nem azonosítjuk.
      </p>

      <p>
        <em>
          3.7.1. <u>A kezelt személyes adatok és az adatkezelés célja</u>
        </em>
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td width="307">személyes adat</td>
            <td width="307">adatkezelés célja</td>
          </tr>
          <tr>
            <td width="307">IP-cím</td>
            <td width="307">
              a Felhasználó hozzávetőleges földrajzi helyének (ország,
              település) meghatározása; az IP-címet nem tároljuk, a
              helymeghatározást követően azonnal törlődik
            </td>
          </tr>
          <tr>
            <td width="307">
              a megtekintett oldalak címe, a látogatás időpontja és időtartama,
              az oldalak betöltési ideje
            </td>
            <td width="307">
              a Weboldal használatának és teljesítményének elemzése
            </td>
          </tr>
          <tr>
            <td width="307">
              a böngésző és az eszköz típusa, az operációs rendszer
            </td>
            <td width="307">
              a csak bizonyos eszközökön vagy böngészőkben jelentkező hibák
              felderítése
            </td>
          </tr>
          <tr>
            <td width="307">
              a Weboldalon előforduló hibák (hibaüzenetek), valamint a Weboldal
              által indított hálózati kérések (például a kosárral kapcsolatos
              műveletek) címe, időtartama és eredménye
            </td>
            <td width="307">a hibák felderítése és javítása</td>
          </tr>
          <tr>
            <td width="307">
              véletlenszerűen generált felhasználói és munkamenet-azonosító
            </td>
            <td width="307">
              a látogatások és munkamenetek megkülönböztetése; a Felhasználó
              hozzájárulása esetén sütiben (ai_user, ai_session) tároljuk,
              hozzájárulás hiányában csak az adott oldalbetöltés idejére
              érvényes
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        <em>
          3.7.2. <u>Az adatkezelés jogalapja</u>
        </em>
      </p>
      <p>
        Az adatkezelő jogos érdeke (GDPR 6. cikk (1) f) pontja), amely a
        Weboldal és a webáruház zavartalan, biztonságos működésének biztosítása
        és a hibák elhárítása. A Felhasználó az adatkezelés ellen tiltakozhat
        (lásd 4. pont). A Felhasználó eszközén (sütiben, illetve a böngésző
        tárhelyén) adatot kizárólag a Felhasználó hozzájárulása esetén tárolunk,
        a részleteket a Süti szabályzat tartalmazza.
      </p>

      <p>
        <em>
          3.7.3. <u>Az adatkezelés időtartama</u>
        </em>
      </p>
      <p>
        Az adatokat a rögzítésüktől számított 90 napig őrizzük meg, ezt követően
        automatikusan törlődnek.
      </p>

      <p>
        <em>
          3.7.4. <u>Az adatkezelés módja</u>
        </em>
      </p>
      <p>
        Elektronikus formában, az adatfeldolgozó (lásd 6.7. pont) Európai
        Unióban található adatközpontjában.
      </p>

      <h2>4. Milyen jogai vannak a Felhasználóknak?</h2>
      <p>
        Számunkra fontos, hogy adatkezelésünk megfeleljen a tisztességesség, a
        jogszerűség és az átláthatóság követelményeinek. Ennek fényében jelen
        pontban röviden bemutatjuk az egyes érintetti jogokat, majd ezeket
        bővebben kifejtjük a tájékoztató 3. számú mellékletében.
      </p>
      <p>
        Felhasználónk ingyenes tájékoztatást kérhet személyes adatai kezelésének
        részleteiről, valamint jogszabályban meghatározott esetekben kérheti
        azok helyesbítését, törlését, zárolását, vagy kezelésének korlátozását,
        és tiltakozhat az ilyen személyes adatok kezelése ellen. A tájékoztatás
        kérését és a jelen pontban szereplő kérelmeket Felhasználónk 2. pontban
        szereplő elérhetőségeinkre tudja címezni.
      </p>

      <p>
        4.1.<u> Hozzáférési jog</u>
      </p>
      <p>
        Felhasználónk visszajelzést kaphat tőlünk személyes adatainak
        kezeléséről és ezekhez a személyes adatokhoz, illetve kezelésük
        részleteihez hozzáférhet.
      </p>

      <p>
        4.2.<u> Helyesbítéshez való jog</u>
      </p>
      <p>
        Felhasználónk kérésére indokolatlan késedelem nélkül helyesbítjük a rá
        vonatkozó pontatlan személyes adatokat, illetve jogosult kérni a hiányos
        személyes adatok – egyebek mellett kiegészítő nyilatkozat útján történő
        – kiegészítését.
      </p>

      <p>
        4.3.<u> Törléshez való jog</u>
      </p>
      <p>
        Felhasználónk kérésére töröljük a rá vonatkozó személyes adatokat, ha
        azok kezelésére nincsen szükségünk, vagy visszavonja hozzájárulását,
        vagy tiltakozik az adatkezelés ellen, vagy kezelésük jogellenes.
      </p>

      <p>
        4.4.<u> Elfeledéshez való jog</u>
      </p>
      <p>
        Felhasználónk törlésre irányuló kérelméről – ha igényli – igyekszünk
        értesíteni minden olyan adatkezelőt, aki Felhasználónk esetlegesen
        nyilvánosságra került adatait megismerte, illetve megismerhette.
      </p>

      <p>
        4.5.<u> Adatkezelés korlátozásához való jog</u>
      </p>
      <p>
        Felhasználónk kérésére korlátozzuk az adatkezelést, ha a személyes
        adatok pontossága vitatott, vagy jogellenes az adatkezelés, vagy
        Felhasználónk tiltakozik az adatkezelés ellen, illetve ha nincsen
        szükségünk a továbbiakban a megadott személyes adatokra.
      </p>

      <p>
        4.6.<u> Adathordozhatósághoz való jog</u>
      </p>
      <p>
        Felhasználónk a rá vonatkozó, általa megadott személyes adatokat tagolt,
        széles körben használt, géppel olvasható formátumban megkaphatja,
        illetve ezeket továbbíthatja egy másik adatkezelőnek.
      </p>

      <p>
        4.7. <u>Reagálás a kérelmekre</u>
      </p>
      <p>
        A kérelmet annak benyújtásától számított legrövidebb időn belül, de
        legfeljebb 30 nap – tiltakozás esetén 15 nap – alatt megvizsgáljuk, és
        annak megalapozottsága kérdésében döntést hozunk, amelyről a kérelmezőt
        írásban tájékoztatjuk. Ha Felhasználónk kérelmét nem teljesítjük,
        döntésünkben közöljük a kérelem elutasításának ténybeli és jogi
        indokait.
      </p>

      <p>
        4.8.<u> Jogorvoslati lehetőségek</u>
      </p>
      <p>
        Számunkra fontos a személyes adatok védelme, egyúttal tiszteletben
        tartjuk a Felhasználók információs önrendelkezési jogát, ezért
        igyekszünk minden kérelemre korrekt módon és határidőn belül reagálni.
        Erre tekintettel kérjük a Tisztelt Felhasználókat, hogy az esetleges
        hatósági és bírósági igényérvényesítés igénybevétele előtt
        szíveskedjenek felvenni a kapcsolatot – panasz megtétele céljából –
        velünk a felmerült konfliktusok békés úton történő rendezése érdekében.
      </p>
      <p>Amennyiben a megkeresés nem vezet eredményre, Felhasználónk</p>
      <ul>
        <li>
          a Polgári Törvénykönyvről szóló 2013. évi V. törvény alapján bíróság
          előtt érvényesítheti jogait (a per Felhasználónk lakóhelye vagy
          tartózkodási helye szerint illetékes törvényszék előtt is
          megindítható; a törvényszékek felsorolását és elérhetőségét az alábbi
          linken keresztül lehet megtekinteni: http://birosag.hu/torvenyszekek),
          valamint
        </li>
      </ul>

      <ul>
        <li>
          az Infotv.-ben foglaltak szerint a Nemzeti Adatvédelmi és
          Információszabadság Hatósághoz (cím: 1125 Budapest, Szilágyi Erzsébet
          fasor 22/c.; telefon: +36-1-391-1400; fax: +36-1-391-1410; e-mail:
          ugyfelszolgalat@naih.hu; honlap:
          https://www.naih.hu/panaszuegyintezes-rendje.html; online ügyindítás:
          https://www.naih.hu/online-uegyinditas.html; a továbbiakban: NAIH)
          fordulhat és panaszt tehet.
        </li>
      </ul>

      <h2>5. Joggyakorlásra irányuló kérelemmel kapcsolatos eljárásunk</h2>

      <p>
        5.1.<u> Címzettek értesítése</u>
      </p>
      <p>
        Helyesbítésről, törlésről, adatkezelés-korlátozásról minden esetben
        értesítjük azokat a címzetteket akikkel, illetve amelyekkel a
        Felhasználó személyes adatait közöltük, kivéve, ha ez lehetetlennek
        bizonyul, vagy aránytalanul nagy erőfeszítést igényel. A Felhasználó
        kérésére tájékoztatást nyújtunk ezekről a címzettekről.
      </p>

      <p>
        5.2.<u> Tájékoztatás módja, határideje</u>
      </p>
      <p>
        A 4. ponthoz kapcsolódó kérelmek nyomán hozott intézkedésekről
        legfeljebb a kérelem beérkezésétől számított egy hónapon belül – ha a
        Felhasználó másként nem kéri – elektronikus formában tájékoztatást
        nyújtunk. Ez a határidő szükség esetén – a kérelem összetettsége,
        illetve a kérelmek számára tekintettel – további két hónappal
        meghosszabbítható. A határidő meghosszabbításáról annak okainak
        megjelölésével a kérelem kézhezvételétől számított egy hónapon belül
        tájékoztatjuk a Felhasználót.
      </p>
      <p>
        A Felhasználó kérésére szóbeli tájékoztatás is adható, feltéve, hogy más
        módon igazolja személyazonosságát.
      </p>
      <p>
        Amennyiben nem intézkedünk a kérelem nyomán, legfeljebb annak
        beérkezésétől számított egy hónapon belül tájékoztatjuk a Felhasználót
        ennek okairól, valamint arról, hogy panaszt nyújthat be a NAIH-nál, és
        élhet bírósági jogorvoslati jogával (4.8. pont).
      </p>

      <p>
        5.3. <u>Ellenőrzés</u>
      </p>
      <p>
        Kivételes esetben, ha megalapozott kétségeink vannak a kérelmet benyújtó
        természetes személy kilétével kapcsolatban, további, személyazonosság
        megerősítéséhez szükséges információk nyújtását kérjük. Ez az intézkedés
        a GDPR 5. cikk (1) bekezdés f) pontjában meghatározott, az adatkezelés
        bizalmasságának elősegítése, azaz a személyes adatokhoz való
        jogosulatlan hozzáférés megakadályozása céljából szükséges.
      </p>

      <p>
        5.4. <u>Tájékoztatás és intézkedés költségei</u>
      </p>
      <p>
        A 4. ponthoz kapcsolódó kérelmekre adott tájékoztatást, illetve az azok
        alapján megtett intézkedéseket díjmentesen biztosítjuk.
      </p>
      <p>
        Ha a Felhasználó kérelme egyértelműen megalapozatlan vagy – különösen
        ismétlődő jellege miatt – túlzó, – figyelemmel a kért információ vagy
        tájékoztatás nyújtásával vagy a kért intézkedés meghozatalával járó
        adminisztratív költségekre – ésszerű díjat számítunk fel, vagy
        megtagadjuk a kérelem alapján történő intézkedést.
      </p>

      <h2>6. Személyes adatok lehetséges címzettjei, adatfeldolgozók</h2>
      <p>
        6.1. <u>Weboldal működésével összefüggésben</u>
      </p>
      <p>
        A Weboldal használata során megadott személyes adatokhoz a
        tárhelyszolgáltató, mint adatfeldolgozó jogosult hozzáférni.
      </p>
      <p>Név: Shopify International Ltd.</p>
      <p>Elérhetőségek:</p>
      <p>Attn: Data Protection Officer</p>
      <p>c/o Intertrust Ireland</p>
      <p>2nd Floor 1-2 Victoria Buildings</p>
      <p>Haddington Road</p>
      <p>Dublin 4, D04 XN32</p>
      <p>Ireland</p>

      <p>
        <a href="https://www.shopify.com/">https://www.shopify.com</a>
      </p>

      <p>
        6.2. <u>Megrendelt termékek kiszállításával összefüggésben</u>
      </p>
      <p>
        A megrendelt termékek kiszállítása érdekében futárcégeket, mint
        adatfeldolgozókat veszünk igénybe. Az adatfeldolgozók adatai az
        alábbiak:
      </p>
      <p>6.2.1.</p>
      <p>Név: Magyar Posta Zrt.</p>
      <p>Elérhetőségek:</p>
      <p>1138 Budapest, Dunavirág utca 2-6.</p>
      <p>
        <a href="https://www.posta.hu/">https://www.posta.hu</a>
      </p>
      <p>6.2.2.</p>
      <p>Név: FoxPost Zrt.</p>
      <p>Elérhetőségek:</p>
      <p>3200 Gyöngyös, Batsányi János utca 9.</p>
      <p>
        <a href="https://foxpost.hu/">https://foxpost.hu</a>
      </p>

      <p>
        6.3. <u>Megrendelés díjának fizetésével összefüggésben</u>
      </p>
      <p>
        A megrendelés díját banki szolgáltató, mint adatfeldolgozó felületén
        keresztül lehet megfizetni. Az adatfeldolgozó adatai az alábbiak:
      </p>
      <p>Név: OTP Mobil Szolgáltató Kft.</p>
      <p>Elérhetőségek:</p>
      <p>1143 Budapest, Hungária krt. 17-19.</p>
      <p>
        <a href="https://simplepay.hu/">https://simplepay.hu</a>
      </p>
      <p>
        A szerződéssel elfogadom, hogy a(z) Salai-Boldizsár Levente E.V.
        (Magyarország, 3533 Miskolc, Szeder utca 76. 2. em. 6. ajtó) által a(z)
        pixwrist.myshopify.com felhasználói adatbázisában tárolt alábbi
        személyes adataim átadásra kerüljenek az OTP Mobil Kft. (1093 Budapest,
        Közraktár u. 30-32.), mint adatkezelő részére. A továbbított adatok
        köre: vezetéknév, keresztnév, ország, telefonszám, e-mail cím. Az
        adattovábbítás célja: a felhasználók részére történő ügyfélszolgálati
        segítségnyújtás, a tranzakciók visszaigazolása és a felhasználók védelme
        érdekében végzett fraud-monitoring.
      </p>
      <p>
        6.4. <u>Közösségi média felületekkel összefüggésben</u>
      </p>
      <p>
        Weboldalunk több közösségi média felülettel is rendelkezik (például
        Facebook, Instagram, YouTube); így ha például a Felhasználó „kedveli” az
        oldalunkat Facebook-on, vagy „követ” bennünket Instagram-on, megismerünk
        minden, profiljához tartozó és nyilvánosság számára elérhető személyes
        adatot. Ezeken az oldalakon felmerülő adatkezelésekről az adott
        szolgáltató saját adatkezelési szabályzatában találhatóak releváns
        információk.
      </p>

      <p>
        6.5. <u>Számla-kiállítással összefüggésben</u>
      </p>
      <p>
        A számlázásokkal kapcsolatban az adóhatóság tevékenysége során jogosult
        megismerni a Felhasználók által e célból megadott személyes adatokat. Az
        adóhatóság adatai:
      </p>
      <p>Név: Nemzeti Adó- és Vámhivatal</p>
      <p>Weboldal, elérhetőségek: https://www.nav.gov.hu/nav/kapcsolat</p>

      <p>
        Továbbá az elektronikus számlázást lehetővé tevő számlázóprogram, mint
        adatfeldolgozó:
      </p>
      <p>Név: Billingo Technologies Zártkörűen Működő Részvénytársaság</p>
      <p>Elérhetőségek:</p>
      <p>1133 Budapest, Árbóc utca 6. 3. em.</p>
      <p>
        <a href="https://www.billingo.hu/">https://www.billingo.hu</a>
      </p>

      <p>
        6.6. <u>Termék értékeléssel összefüggésben</u>
      </p>
      <p>
        A Weboldal használata során igénybe vehető termék értékelés szolgáltatás
        üzemeltetője adatfeldolgozóként szintén hozzáférhet a Felhasználók
        személyes adataihoz.
      </p>
      <p>Név: Stamped.io</p>
      <p>Elérhetőségek:</p>
      <p>
        <a href="https://stamped.io/">https://stamped.io</a>
      </p>

      <p>
        6.7. <u>A Weboldal működésének monitorozásával összefüggésben</u>
      </p>
      <p>
        A Weboldal működésének és hibáinak monitorozásához (lásd 3.7. pont) a
        Microsoft Azure Application Insights szolgáltatást vesszük igénybe,
        amelynek üzemeltetője adatfeldolgozóként hozzáfér az ott felsorolt
        adatokhoz.
      </p>
      <p>Név: Microsoft Ireland Operations Limited</p>
      <p>Elérhetőségek:</p>
      <p>One Microsoft Place, South County Business Park</p>
      <p>Leopardstown, Dublin 18, D18 P521</p>
      <p>Ireland</p>
      <p>
        <a href="https://privacy.microsoft.com/">
          https://privacy.microsoft.com
        </a>
      </p>

      <p>
        6.8. <u>Látogatottsági statisztikák készítésével összefüggésben</u>
      </p>
      <p>
        A Weboldal látogatottságának méréséhez a Google Analytics szolgáltatást
        vesszük igénybe, amelynek üzemeltetője adatfeldolgozóként hozzáfér a
        Weboldal használatával kapcsolatos adatokhoz. A szolgáltatás kizárólag a
        Felhasználó hozzájárulása esetén működik, az általa használt sütiket és
        a szolgáltatás részleteit a Süti szabályzat tartalmazza.
      </p>
      <p>Név: Google Ireland Limited</p>
      <p>Elérhetőségek:</p>
      <p>Gordon House, Barrow Street</p>
      <p>Dublin 4</p>
      <p>Ireland</p>
      <p>
        <a href="https://policies.google.com/privacy">
          https://policies.google.com/privacy
        </a>
      </p>

      <p>
        6.9. <u>A Weboldal használatának elemzésével összefüggésben</u>
      </p>
      <p>
        A Weboldal használatának elemzéséhez (például annak megértéséhez, hogy a
        Felhasználók hogyan navigálnak az oldalakon) a Hotjar szolgáltatást
        vesszük igénybe, amelynek üzemeltetője adatfeldolgozóként hozzáfér a
        Weboldal használatával kapcsolatos adatokhoz. A szolgáltatás kizárólag a
        Felhasználó hozzájárulása esetén működik, az általa használt sütiket a
        Süti szabályzat tartalmazza.
      </p>
      <p>Név: Hotjar (a Contentsquare vállalatcsoport tagja)</p>
      <p>Elérhetőségek:</p>
      <p>
        <a href="https://contentsquare.com/privacy-policy/visitor-privacy-policy/">
          https://contentsquare.com/privacy-policy/visitor-privacy-policy/
        </a>
      </p>

      <h2>7. Adatbiztonság</h2>
      <p>
        A Felhasználó személyes adatai megismerésére a mi és az adatfeldolgozók
        alkalmazottai a munkakörükbe tartozó feladatok teljesítéséhez szükséges
        mértékben jogosultak. Megteszünk minden olyan biztonsági, technikai és
        szervezési intézkedést, mely az adatok biztonságát garantálja.
      </p>
      <p>
        7.1. <u>Szervezési intézkedések </u>
      </p>
      <p>
        Informatikai rendszereinkhez a hozzáférést személyhez köthető
        jogosultsággal tesszük lehetővé. A hozzáférések kiosztásánál érvényesül
        a „szükséges és elégséges jogok elve”, azaz informatikai rendszereinket
        és szolgáltatásainkat minden alkalmazott csak a feladatának ellátásához
        szükséges mértékben, az ennek megfelelő jogosultságokkal és a szükséges
        időtartamig használhatja. Az informatikai rendszerekhez és
        szolgáltatásokhoz hozzáférési jogot csak az a személy kaphat, aki
        biztonsági vagy egyéb (pl. összeférhetetlenségi) okokból nem esik
        korlátozás alá, valamint rendelkezik az annak biztonságos használatához
        szükséges szakmai, üzleti és információbiztonsági ismeretekkel.
      </p>
      <p>
        Mi és az adatfeldolgozók írásos nyilatkozatban szigorú titoktartási
        szabályokat vállalunk, és a tevékenységünk során ezek szerint a
        titoktartási szabályok szerint kötelesek vagyunk eljárni.
      </p>
      <p>
        7.2. <u>Technikai intézkedések</u>
      </p>
      <p>
        Az adatokat – az adatfeldolgozóink által tárolt adatok kivételével –
        saját eszközeinken, adatközpontban tároljuk. Az adatokat tároló
        informatikai eszközöket elhatároltan, külön zárt szerverteremben
        tároljuk, többlépcsős, jogosultság ellenőrzéshez kötött beléptető
        rendszerrel védetten.
      </p>
      <p>
        Többszintű, tűzfalas védelemmel védjük a belső hálózatunkat. Az
        alkalmazott nyilvános hálózatok belépési pontjain mindenhol minden
        esetben hardveres tűzfal (határvédelmi eszköz) helyezkedik el. Az
        adatokat redundánsan – azaz több helyen – tároljuk, hogy védjük azokat
        az informatikai eszköz meghibásodásából fakadó megsemmisüléstől,
        elvesztéstől, sérüléstől, a jogellenes megsemmisítéstől.
      </p>
      <p>
        Többszintű, aktív, komplex kártékony kódok elleni védelemmel (pl.
        vírusvédelem) védjük a belső hálózatainkat a külső támadásoktól. Az
        általunk működtetett informatikai rendszerekhez, adatbázisokhoz az
        elengedhetetlen külső elérést titkosított adatkapcsolaton keresztül
        valósítjuk meg (VPN).
      </p>
      <p>
        Mindent megteszünk azért, hogy informatikai eszközeink, szoftvereink
        folyamatosan megfeleljenek a piaci működésben általánosan elfogadott
        technológiai megoldásoknak.
      </p>
      <p>
        A fejlesztéseink során olyan rendszereket alakítunk ki, amelyekben a
        naplózás révén kontrollálhatók és nyomon követhetők a végzett műveletek,
        észlelhetők a bekövetkezett incidensek, például a jogosulatlan
        hozzáférés.
      </p>
      <p>
        Szerverünk a tárhelyszolgáltató elkülönített dedikált szerverén,
        védetten és zártan található.
      </p>
      <p>
        A NAIH pártok honlapjain végzett adatkezelések adatvédelmi
        követelményeiről szóló{' '}
        <a href="https://naih.hu/files/ajanlas_honlapok-2018-02-19.pdf">
          ajánlás
        </a>{' '}
        figyelembevételével a weboldalon <em>https protokollt</em> használunk,
        amely magasabb adatbiztonsági szintet jelent a <em>http protokolhoz</em>{' '}
        képest.
      </p>

      <h2>8. Sütik (cookies)</h2>
      <p>
        Weboldalunk megfelelő működése érdekében bizonyos esetekben apró adat
        fájlokat helyezünk el a Felhasználó számítógépes eszközén, a legtöbb
        modern honlaphoz hasonlóan.
      </p>
      <p>
        8.1.<u> Mi az a süti?</u>
      </p>
      <p>
        A süti egy olyan, kisméretű szöveges fájl, amit a honlap a Felhasználó
        számítógépes eszközére (beleértve a mobil telefonokat is) helyez el.
        Ennek köszönhetően a honlap „emlékezni” tud a Felhasználó beállításaira
        (pl.: használt nyelv, betűméret, megjelenítés, stb.), így nem kell azt
        minden alkalommal újra beállítani, amikor felkeresi weboldalunkat.
      </p>
      <p>
        A Weboldalon használt sütikről részletes információ a Süti szabályzatban
        található:
      </p>
      <p>
        <a href="https://www.pixwrist.hu/legal/cookie-policy">
          https://www.pixwrist.hu/legal/cookie-policy
        </a>
      </p>

      <h2>9. Egyéb rendelkezések</h2>
      <p>
        9.1. <u>Adatgyűjtés aktivitásról</u>
      </p>
      <p>
        A Felhasználók aktivitásáról adatokat gyűjthetünk, melyek nem
        kapcsolhatók össze a Felhasználó által a regisztrációkor megadott egyéb
        adatokkal, sem más honlapok vagy szolgáltatások igénybevételekor
        keletkező adatokkal.
      </p>

      <p>
        9.2. <u>Adatkezelés eltérő célra</u>
      </p>
      <p>
        Ha a szolgáltatott adatokat az eredeti adatfelvétel céljától eltérő
        célra kívánjuk felhasználni, akkor erről a Felhasználókat tájékoztatjuk,
        és ehhez előzetes, kifejezett hozzájárulásukat megszerezzük, illetőleg
        lehetőséget biztosítunk számukra, hogy a felhasználást megtiltsák.
      </p>

      <p>
        9.3. <u>Nyilvántartási kötelezettség</u>
      </p>
      <p>
        A felelősségünkbe tartozóan végzett adatkezelési tevékenységekről
        nyilvántartást vezetünk (adatkezelési tevékenység nyilvántartása) a GDPR
        30. cikkének megfelelően.
      </p>

      <p>
        9.4. <u>Adatvédelmi incidens</u>
      </p>
      <p>
        Adatvédelmi incidens a biztonság olyan sérülése, amely a kezelt
        személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését,
        megváltoztatását, jogosulatlan közlését vagy az azokhoz való
        jogosulatlan hozzáférést eredményezi. Adatvédelmi incidens esetén a GDPR
        33. és 34. cikkei szerint vagyunk köteles eljárni. Nyilvántartjuk az
        adatvédelmi incidenseket, feltüntetve az adatvédelmi incidenshez
        kapcsolódó tényeket, annak hatásait és az orvoslására tett
        intézkedéseket.
      </p>

      <p>
        9.5. <u>Módosítás</u>
      </p>
      <p>
        Bármikor jogosultak vagyunk jelen Tájékoztatót egyoldalúan módosítani.
      </p>

      <p>Hatályos: 2020. 09. 12.</p>
      <p>
        <strong>Salai-Boldizsár Levente e.v.</strong>
      </p>
      <p>Adatkezelő</p>

      <h2>1. számú melléklet</h2>
      <h3>A vonatkozó jogszabályok</h3>

      <p>
        A Tájékoztató kialakítása során az Adatkezelő figyelembe vette a
        vonatkozó hatályos jogszabályokat, illetve a fontosabb nemzetközi
        ajánlásokat, különös tekintettel az alábbiakra:
      </p>
      <ul>
        <li>
          a természetes személyeknek a személyes adatok kezelése tekintetében
          történő védelméről és az ilyen adatok szabad áramlásáról, valamint a
          95/46/EK irányelv hatályon kívül helyezéséről szóló, 2016. április
          27-i 2016/679/EU európai parlamenti és tanácsi rendelet (GDPR);
        </li>
        <li>
          az információs önrendelkezési jogról és az információszabadságról
          szóló 2011. évi CXII. törvény 2011. évi CXII. törvény (Infotv.);
        </li>
        <li>a Polgári Törvénykönyvről szóló 2013. évi V. törvény (Ptk.);</li>
        <li>a polgári perrendtartásról szóló 2016. évi CXXX. törvény (Pp);</li>
        <li>a számvitelről szóló 2000. évi C. törvény (Számv. tv.);</li>
        <li>a fogyasztóvédelemről szóló 1997. évi CLV. törvény (Fgytv.);</li>
        <li>
          az elektronikus kereskedelmi szolgáltatások, valamint az információs
          társadalommal összefüggő szolgáltatások egyes kérdéseiről szóló 2001.
          évi CVIII. törvény (Elkertv.)
        </li>
      </ul>

      <h2>2. számú melléklet</h2>
      <h3>A személyes adatok kezelésével kapcsolatos fogalmak</h3>
      <ul>
        <li>
          adatkezelő: az a jogi személy, amely a személyes adatok kezelésének
          céljait és eszközeit meghatározza;
        </li>
      </ul>

      <ul>
        <li>
          adatkezelés: a személyes adatokon vagy adatállományokon automatizált
          vagy nem automatizált módon végzett bármely művelet vagy műveletek
          összessége, így a gyűjtés, rögzítés, rendszerezés, tagolás, tárolás,
          átalakítás vagy megváltoztatás, lekérdezés, betekintés, felhasználás,
          közlés, továbbítás, terjesztés vagy egyéb módon történő hozzáférhetővé
          tétel útján, összehangolás vagy összekapcsolás, korlátozás, törlés,
          illetve megsemmisítés;
        </li>
        <li>
          adattovábbítás: az adat meghatározott harmadik személy számára történő
          hozzáférhetővé tétele;
        </li>
        <li>
          adattörlés: az adatok felismerhetetlenné tétele oly módon, hogy a
          helyreállításuk többé nem lehetséges;
        </li>
        <li>
          adatmegjelölés: az adat azonosító jelzéssel ellátása annak
          megkülönböztetése céljából;
        </li>
        <li>
          adatkezelés korlátozása: a tárolt személyes adatok megjelölése
          jövőbeli kezelésük korlátozása céljából;
        </li>
        <li>
          adatmegsemmisítés: az adatokat tartalmazó adathordozó teljes fizikai
          megsemmisítése;
        </li>
        <li>
          adatfeldolgozó: az a jogi személy, amely az adatkezelő nevében
          személyes adatokat kezel;
        </li>
        <li>
          címzett: az a természetes vagy jogi személy, közhatalmi szerv,
          ügynökség vagy bármely egyéb szerv, akivel vagy amellyel a személyes
          adatot közlik, függetlenül attól, hogy harmadik fél-e;
        </li>
        <li>
          cookie: a webszerver által küldött és a felhasználó számítógépén
          meghatározott időre elhelyezett kis adatcsomag (szöveges fájl), amit
          annak jellégétől függően a szerver az újabb látogatások alkalmával ki
          is egészíthet, azaz, ha a böngésző visszaküld egy korábban elmentett
          sütit, a sütit kezelő szolgáltatónak lehetősége van összekapcsolni a
          felhasználó aktuális látogatását a korábbiakkal, de kizárólag a saját
          tartalma tekintetében;
        </li>
        <li>
          érintett/felhasználó: azonosított vagy azonosítható természetes
          személy; azonosítható az a természetes személy, aki közvetlen vagy
          közvetett módon, különösen valamely azonosító, például név, szám,
          helymeghatározó adat, online azonosító vagy a természetes személy
          testi, fiziológiai, genetikai, szellemi, gazdasági, kulturális vagy
          szociális azonosságára vonatkozó egy vagy több tényező alapján
          azonosítható;
        </li>
        <li>
          harmadik személy: az a természetes vagy jogi személy, közhatalmi
          szerv, ügynökség vagy bármely egyéb szerv, amely nem azonos az
          érintettel, az adatkezelővel, az adatfeldolgozóval vagy azokkal a
          személyekkel, akik az adatkezelő vagy adatfeldolgozó közvetlen
          irányítása alatt a személyes adatok kezelésére felhatalmazást kaptak;
        </li>
        <li>
          az érintett hozzájárulása: az érintett akaratának önkéntes, konkrét és
          megfelelő tájékoztatáson alapuló és egyértelmű kinyilvánítása,
          amellyel az érintett nyilatkozat vagy a megerősítést
          félreérthetetlenül kifejező cselekedet útján jelzi, hogy beleegyezését
          adja az őt érintő személyes adatok kezeléséhez;
        </li>
        <li>
          IP cím: valamennyi hálózatban, amelyben a kommunikáció a
          TCP/IP-protokoll szerint folyik, a szervergépek IP-címmel, azaz
          azonosítószámmal rendelkeznek, amelyek az adott gépek hálózaton
          keresztüli azonosítását teszik lehetővé. Tudvalévő, hogy minden
          hálózatra kapcsolt számítógép rendelkezik IP címmel, amelyen keresztül
          beazonosítható.
        </li>
        <li>személyes adat: az érintettre vonatkozó bármely információ.;</li>
        <li>
          tiltakozás: az érintett nyilatkozata, amellyel személyes adatainak
          kezelését kifogásolja, és az adatkezelés megszüntetését, illetve a
          kezelt adatok törlését kéri.
        </li>
      </ul>

      <h2>3. számú melléklet</h2>
      <h3>Érintetti jogok</h3>
      <p>
        <strong>Hozzáférés </strong>
      </p>
      <p>
        A Felhasználó jogosult arra, hogy – elérhetőségeink valamelyikén
        benyújtott – kérelmére hozzáférést kapjon az általunk által kezelt
        személyes adataihoz. Ennek keretében a Felhasználó az alábbiakról kap
        tájékoztatást:
      </p>
      <ul>
        <li>személyes adatainak kezelése folyamatban van-e;</li>
        <li>az adatkezelés céljai;</li>
        <li>az érintett személyes adatok kategóriái;</li>
        <li>
          azon címzettek vagy címzettek kategóriái, akikkel, illetve amelyekkel
          a személyes adatokat közölték vagy közölni fogják;
        </li>
        <li>a személyes adatok tárolásának tervezett időtartama;</li>
        <li>jogai;</li>
        <li>jogorvoslati lehetőségei;</li>
        <li>az adatforrásokra vonatkozó információ.</li>
      </ul>

      <p>
        A Felhasználó kérheti továbbá az adatkezelés tárgyát képező személyes
        adatai másolatának rendelkezésére bocsátását is. Ebben az esetben a
        személyes adatokat tagolt, széles körben használt, számítógéppel
        olvasható formátumban (PDF/XML), illetve annak kinyomtatott
        változatában, papír alapon bocsátjuk rendelkezésre. A másolat igénylése
        ingyenes.
      </p>

      <p>
        <strong>Helyesbítés </strong>
      </p>
      <p>
        A Felhasználó – elérhetőségeinken keresztül benyújtott kérelem alapján –
        jogosult kérni az általunk kezelt, rá vonatkozó pontatlan személyes
        adatok helyesbítését és a hiányos adatok kiegészítését. Amennyiben a
        valóságnak nem megfelelő információk pontosításához, kiegészítéséhez
        szükséges információk nem állnak rendelkezésünkre, kérhetjük ezen
        kiegészítő adatok benyújtását, az adatok pontosságának igazolását.
        Ameddig az adatok pontosítása, kiegészítése – a kiegészítő információk
        hiányában – nem végezhető el, korlátozzuk az érintett személyes adatok
        kezelését, az azokon végzett műveleteket – a tárolás kivételével –
        ideiglenesen felfüggesztjük.
      </p>
      <p>
        <strong>Törlés </strong>
      </p>
      <p>
        A Felhasználó – elérhetőségeinken keresztül benyújtott kérelem alapján –
        jogosult kérni az általunk kezelt, rá vonatkozó személyes adatok
        törlését, amennyiben a következő feltételek valamelyike fennáll:
      </p>
      <ul>
        <li>a továbbiakban már nincs szükségünk az adott adatokra;</li>
        <li>
          aggodalma merül fel az adatai általunk történő adatkezelésének
          jogszerűsége tekintetében.
        </li>
      </ul>

      <p>
        Amennyiben a Felhasználó kérelme nyomán megállapítjuk, hogy az általunk
        kezelt személyes adatok törlésének kötelezettsége fennáll, az adatok
        kezelését megszüntetjük, a korábban kezelt személyes adatokat pedig
        megsemmisítjük. Emellett a személyes adatok törlésének kötelezettsége a
        hozzájárulás visszavonása, a tiltakozási jog gyakorlása, valamint
        jogszabályi kötelezettségek alapján is fennállhat.
      </p>

      <p>
        <strong>Az adatkezelés korlátozása </strong>
      </p>
      <p>
        A Felhasználó – elérhetőségeinken keresztül benyújtott kérelem alapján –
        jogosult kérni az általunk kezelt, rá vonatkozó személyes adatok
        kezelésének korlátozását az alábbi esetekben:
      </p>
      <ul>
        <li>
          aggodalma merül fel az általunk kezelt, rá vonatkozó személyes adatok
          kezelésének jogszerűsége tekintetében és az adatok törlése helyett
          kéri a korlátozást;
        </li>
        <li>
          a továbbiakban már nincs szükségünk az adott adatokra, de a
          Felhasználó igényli azokat jogi igények előterjesztéséhez,
          érvényesítéséhez vagy védelméhez.
        </li>
      </ul>

      <p>
        Automatikusan korlátozzuk a személyes adatok kezelését abban az esetben,
        ha a Felhasználó vitatja a személyes adatok pontosságát, illetve, ha a
        Felhasználó tiltakozáshoz való jogát gyakorolja. Ez esetben a korlátozás
        arra az időtartamra vonatkozik, amely lehetővé teszi, a személyes adatok
        pontosságának ellenőrzését, illetve – tiltakozás esetén – annak
        megállapítását, hogy fennállnak- e az adatkezelés folytatásának
        felételei.
      </p>
      <p>
        A korlátozás ideje alatt a megjelölt személyes adatokon adatkezelési
        műveletek nem végezhetők, csak tárolni lehet az adatokat. A személyes
        adatokat az adatkezelés korlátozása esetén kizárólag az alábbi esetekben
        lehet kezelni:
      </p>
      <ul>
        <li>az érintett hozzájárulása alapján;</li>
        <li>jogi igények előterjesztése, érvényesítése vagy védelme;</li>
        <li>más természetes vagy jogi személy jogainak védelme;</li>
        <li>fontos közérdek.</li>
      </ul>

      <p>
        A korlátozás feloldásáról előzetesen tájékoztatjuk a Felhasználókat.
      </p>
      <p>
        <strong>Adathordozhatóság </strong>
      </p>
      <p>
        A Felhasználó – elérhetőségeinken keresztül benyújtott kérelem alapján –
        jogosult kérni az általunk kezelt, rá vonatkozó személyes adatok
        rendelkezésre bocsátását azok további, Felhasználó által meghatározott
        felhasználása érdekében. Emellett a Felhasználó kérheti azt is, hogy egy
        általa megjelölt másik adatkezelő részére továbbítsuk a személyes
        adatait.
      </p>
      <p>
        E jogosultság kizárólag a Felhasználó által rendelkezésünkre bocsátott,
        szerződése teljesítése érdekében kezelt személyes adatokra korlátozódik.
        Egyéb adatok hordozhatóságára lehetőség nincs. A személyes adatokat
        tagolt, széles körben használt, számítógéppel olvasható formátumban
        (PDF/XML), illetve annak kinyomtatott változatában, papír alapon
        bocsátjuk a Felhasználó rendelkezésre.
      </p>
      <p>
        Tájékoztatjuk a Felhasználót arról, hogy e jog gyakorlása nem jár
        automatikusan a személyes adatok rendszereinkből való törlésével.
        Emellett a Felhasználó az adatok hordozását követően is jogosult a
        velünk történő ismételt kapcsolatfelvételre vagy kapcsolattartásra.
      </p>

      <p>
        <strong>Tiltakozás </strong>
      </p>
      <p>
        A Felhasználó – elérhetőségeinken keresztül benyújtott kérelem alapján –
        bármikor tiltakozhat a személyes adatai regisztráció céljából történő
        kezelése ellen. Ebben az esetben az Adatkezelő megvizsgálja, hogy az
        adatkezelést olyan kényszerítő erejű jogos okok indokolják-e, amelyek
        elsőbbséget élveznek a Felhasználó érdekeivel, jogaival és
        szabadságaival szemben, vagy amelyek jogi igények előterjesztéséhez,
        érvényesítéséhez vagy védelméhez kapcsolódnak. Amennyiben azt állapítjuk
        meg, hogy ilyen okok fennállnak, a személyes adatok kezelését
        folytatjuk. Ellenkező esetben a személyes adatokat tovább nem kezeljük.
      </p>
    </>
  );
}
